import { BaseController } from './BaseController';

export default class LazyLoaderController extends BaseController {
  id = 'LazyLoaderController';

  init() {
    this.root = this.getRoot();
    this.observer = null;
    this.observedItems = [];

    const customThreshold = this.getData(this.root, 'thresholdIncrement');
    const customMargin = this.getData(this.root, 'margin');
    this.options = {
      rootMargin: !customMargin ? '50px' : customMargin,
      threshold: [0, 0.25, 0.5, 0.75, 1],
    };

    this.startObserver();
    // window.addEventListener('load', this.startObserver);
    window.addEventListener('lazy_load', this.handleNewItems);
  }

  startObserver = () => {
    this.observer = new IntersectionObserver(
      this.handleObserverCallback,
      this.options,
    );
    this.addElemsToObserver();
  };

  addElemsToObserver = () => {
    this.childNodes('image-tag').forEach((el) => {
      el.classList.add('image-tag-placeholder-spinner');
      this.observer.observe(el);
      this.observedItems.push(el);
    });
  };

  handleNewItems = () => {
    this.childNodes('image-tag').forEach((el) => {
      if (
        this.getData(el, 'isReplaced') === undefined &&
        !this.observedItems.includes(el)
      ) {
        this.observer.observe(el);
        this.observedItems.push(el);
      }
    });
  };

  getWatchedElems() {
    return this.observedItems;
  }

  handleObserverCallback = (entries) => {
    entries.forEach((entry) => {
      if (
        entry.isIntersecting &&
        this.getData(entry.target, 'isReplaced') === undefined
      ) {
        const elem = entry.target;
        this.loadImage(elem)
          .then((el) => {
            var imgTemp = el.el.getElementsByClassName('image-temp')[0];
            if (imgTemp) {
              imgTemp.classList.add('d-none');
            }

            el.picture.classList.remove('d-none');
            el.el.classList.remove('image-tag-placeholder-spinner');
            
          }).catch(err => console.error(err));

        this.observer.unobserve(elem);
        this.observedItems.forEach((arrElem) => {
          if (arrElem === elem) {
            this.observedItems.splice(this.observedItems.indexOf(arrElem), 1);
          }
        });
      }
    });
  };

  loadImage = (elem) => new Promise((resolve, reject) => {
    const largeImageUrl = this.getData(elem, 'imageLargeUrl');
    const smallImageUrl = this.getData(elem, 'imageSmallUrl');
    const imageChangeWidth = this.getData(elem, 'imageChangeWidth');
    const imageAlt = this.getData(elem, 'imageAlt');

    const pictureElem = document.createElement('picture');
    pictureElem.classList.add('d-none');
    const sourceElem = document.createElement('source');
    sourceElem.srcset = largeImageUrl;
    sourceElem.media = imageChangeWidth;
    const imgData = new Image();
    imgData.addEventListener('load', () => resolve({'el': elem, 'picture': pictureElem}));
    imgData.addEventListener('error', err => reject(err))
    imgData.src = smallImageUrl;
    imgData.alt = imageAlt;

    pictureElem.appendChild(sourceElem);
    pictureElem.appendChild(imgData);

    elem.prepend(pictureElem);
    this.setData(elem, 'isReplaced', true);
    this.toggleClass(elem, 'is-replaced', 'on');
  });
}
